import { Component, OnInit } from '@angular/core';
import { Grid } from '../../../core/components/grid/grid.model';
import { GridOptions } from '../../../core/components/grid/grid.types';
import { DataTaskService } from '../../../core/services/data-task.service';
import { StateService } from '../../../core/services/state.service';

@Component({
    selector: 'tt-calculation-overview',
    templateUrl: './calculation-overview.component.html',
    styleUrls: ['./calculation-overview.component.css'],
    standalone: false
})
export class CalculationOverviewComponent implements OnInit {
    calculationSeasonYearKeyno;

    public grid?: GridOptions;

    constructor(private stateService: StateService, private datatask: DataTaskService) {
        this.calculationSeasonYearKeyno = this.stateService.getStateParams()['calculationseasonyear_keyno'];
    }

    private loadGrid() {
        if (!!this.calculationSeasonYearKeyno) {
            if (!this.grid) {
                this.grid = new Grid()
                    .setRememberId('w_calculationoverview')
                    .setLoadDataFunction({
                        method: 2256,
                        parameters: { calculationseasonyear_keyno: this.calculationSeasonYearKeyno }
                    })
                    .setKendoConfig({ height: '100%' })
                    .setToolbar({ wrapping: true })
                    .setCustomToolbarButtons([{
                        name: 'recalculate',
                        text: 'recalculate',
                        tooltip: 'recalculate',
                        translateTooltip: true,
                        func: () => this.prepareRecalculation(),
                        icon: 'fas fa-calculator',
                        cssClass: 'tt-button tt-button--primary im-grid-btn-xs-r',
                        translate: true,
                        disabled: () => { return this.hasDirty(); }
                    }]);
            } else {
                this.grid?.gridfunc?.read();
            }
        }
    }

    private async prepareRecalculation(): Promise<void> {
        const items = this.getIsSelectedItems();
        this.grid?.gridfunc?.gridProgress(true);

        try {
            await Promise.all(items.map((row) => this.datatask.Post(2640, { calculationhead_keyno: row['calculationhead_keyno'] })));
            this.grid?.gridfunc?.rebind();
        } finally {
            this.grid?.gridfunc?.gridProgress(false);
        }
    }

    private getIsSelectedItems(): any[] {
        const dirtyItems = this.grid?.gridfunc?.getDirtyRows() ?? [];

        return dirtyItems.filter((row) => row['is_selected'] === true || row['is_selected'] === '1');
    }

    private async hasDirty() {
        let parmItems = this.getIsSelectedItems();

        if (parmItems.length > 0) return false;

        return true;
    }

    private async init() {
        this.loadGrid();
    }

    ngOnInit() {
        this.init();
    }
}
